import React from 'react'

export const AppContext = React.createContext({
    user: null,
    organisation: null,
    permissions: null,
    authToken: null,
    menu: [],
    twoFactorPending: false,
    twoFactorData: null,
    login: () => void 0,
    logout: () => void 0,
    setPendingTwoFactor: () => void 0,
    clearPendingTwoFactor: () => void 0
});
